import styled from 'styled-components';
import { device } from '../../style/device';
import { Section } from '../../style/section';

export const StyledContainer = styled(Section)`
    position: realtive;
    max-width: 80%;
    
`;
export const StyledFlexContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    ${device.tablet`display: block;`};
`;

export const StyledTechnoWrapper = styled.div`
    
    border-radius:10px;
    width:200px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    margin-right:20px;
    margin-bottom:20px;
`;